"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildStorage = void 0;
const tools_1 = require("@axiom-crypto/tools");
const utils_1 = require("../utils");
const halo2_lib_js_1 = require("@axiom-crypto/halo2-lib-js");
const data_1 = require("./data");
const buildStorage = (blockNumber, addr) => {
    const slot = (slot) => {
        if (slot instanceof halo2_lib_js_1.CircuitValue) {
            slot = (0, utils_1.getCircuitValue256FromCircuitValue)(slot);
        }
        if (typeof slot === "string" || typeof slot === "number" || typeof slot == "bigint") {
            slot = (0, utils_1.getCircuitValue256Constant)(slot);
        }
        let storageSubquery = {
            blockNumber: blockNumber.number(),
            addr: addr.address(),
            slot: slot.hex()
        };
        const dataSubquery = { subqueryData: storageSubquery, type: tools_1.DataSubqueryType.Storage };
        return (0, data_1.prepData)(dataSubquery, [blockNumber, addr, slot.hi(), slot.lo()]);
    };
    const storage = { slot };
    return Object.freeze(storage);
};
exports.buildStorage = buildStorage;
//# sourceMappingURL=storage.js.map